import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFork: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFork"><Path d="M5.5 2.5L4.5 15L8.5 19V21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M10 13.5V2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14 2.5V13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M18.5 2.5L19.5 15L15.5 19V21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFork;
